import './index.scss';

import React, { Component } from 'react';
import ComponentSlider from '@kapost/react-component-slider';

import MenuItem from '../menu-items';
import GeneralCard from '../card-general';
import SectionTitle from '../section-title';

import { getRightArrowImage } from '../../utils/imageChanges';

import LeftArrowDisabled from '../../../assets/images/left-arrow-disabled.svg';

class HorizontalScroll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hideArrowSeeAll: false
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.updateArrowDisplay();
  }

  updateArrowDisplay = () => {
    const SliderWidth =
      this.ref &&
      this.ref.current &&
      this.ref.current.slider &&
      this.ref.current.slider.scrollWidth;
    const ElementWidth =
      this.ref &&
      this.ref.current &&
      this.ref.current.sliderContent &&
      this.ref.current.sliderContent.scrollWidth;
    if (SliderWidth > ElementWidth + 50) {
      this.setState({ hideArrowSeeAll: true });
    }
  };

  renderContent = () => {
    const { cardType, data, onClick } = this.props;

    const midpoint = Math.ceil(data.length / 2);
    const firstRow = data.slice(0, midpoint);
    const secondRow = data.slice(midpoint);
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const rows = isMobile ? [firstRow, secondRow] : [data];

    switch (cardType) {
      case 'menu':
        return (
          <div>
            {rows.map((row, rowIndex) => (
              <div key={rowIndex} className="row">
                {row.map(item => (
                  <MenuItem menu={item} key={item.id} onClick={onClick} />
                ))}
              </div>
            ))}
          </div>
        );

      default:
        return <div>No content available</div>;
    }
  };

  rightArrowClick = () => {};

  render() {
    const { rightArrowClick, renderContent } = this;
    const {
      contentData,
      arrowPosition,
      theme,
      customClass,
      cardType,
      sectionShowSeeAll,
      sectionTitle,
      sectionOnClick,
      sectionSeeAllData,
      sectionIndex
    } = this.props;
    const { hideArrowSeeAll } = this.state;

    const renderRightArrow = () => (
      <div
        className={`htl-scroll__arrow htl-scroll__arrow_right htl-scroll-rgt ${arrowPosition &&
          `htl-scroll__arrow_${arrowPosition}`}`}
        role="presentation"
        onClick={() => rightArrowClick()}
      >
        <img
          src={getRightArrowImage(theme)}
          alt="leftArrow"
          className="htl-scroll__icon"
        />
      </div>
    );
    const renderLeftArrow = () => (
      <div
        className={`htl-scroll__arrow htl-scroll-lft ${arrowPosition &&
          `htl-scroll__arrow_${arrowPosition}`}`}
      >
        <img
          src={getRightArrowImage(theme)}
          alt="leftArrow"
          className="htl-scroll__icon htl-scroll__icon_left"
        />
      </div>
    );

    return (
      <>
        {sectionTitle ? (
          <SectionTitle
            title={sectionTitle}
            showSeeAll={!hideArrowSeeAll ? sectionShowSeeAll : false}
            theme={theme}
            onClick={sectionOnClick}
            seeAllData={sectionSeeAllData}
            index={sectionIndex}
          />
        ) : (
          ''
        )}
        <div
          className={`htl-scroll ${arrowPosition &&
            `htl-scroll_${arrowPosition}`} ${customClass && customClass}`}
        >
          {!hideArrowSeeAll ? (
            <div
              className={`htl-scroll__arrow htl-scroll__arrow_disabled htl-scroll__arrow_left 
              ${arrowPosition && `htl-scroll__arrow_${arrowPosition}`}`}
              role="presentation"
              onClick={() => rightArrowClick()}
            >
              <img
                src={LeftArrowDisabled}
                alt="leftArrow"
                className="htl-scroll__icon"
              />
            </div>
          ) : (
            ''
          )}

          <ComponentSlider
            renderRightArrow={
              !hideArrowSeeAll ? renderRightArrow : this.rightArrowClick
            }
            renderLeftArrow={
              !hideArrowSeeAll ? renderLeftArrow : this.rightArrowClick
            }
            ref={this.ref}
          >
            {cardType ? renderContent() : contentData}
          </ComponentSlider>
          {!hideArrowSeeAll ? (
            <div
              className={`htl-scroll__arrow htl-scroll__arrow_disabled htl-scroll__arrow_right 
                ${arrowPosition && `htl-scroll__arrow_${arrowPosition}`}`}
              role="presentation"
              onClick={() => rightArrowClick()}
            >
              <img
                src={LeftArrowDisabled}
                alt="leftArrow"
                className="htl-scroll__icon htl-scroll__icon-disabled-right"
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </>
    );
  }
}

export default HorizontalScroll;
